import { CSVLink } from 'react-csv';
import PropTypes from 'prop-types';

export const ButtonDownloadExcelComponent = ({ csvData, fileName = "data.csv", className = '' }: any) => {
    return csvData ? (
        <div className="">
            <CSVLink data={csvData} filename={fileName}>
                <div className={`btn btn-download ${className}`}>
                    <span>Descargar</span>
                </div>
            </CSVLink>
        </div>
    ) : <></>
}

export function CsvSampleData() {
    return [
        ["firstname", "lastname", "email"],
        ["Ahmed", "Tomi", "ah@smthing.co.com"],
        ["Raed", "Labes", "rl@smthing.co.com"],
        ["Yezzi", "Min l3b", "ymin@cocococo.com"]
    ];
}

ButtonDownloadExcelComponent.propTypes = {
    fileName: PropTypes.string.isRequired,
    csvData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any)).isRequired,
    className: PropTypes.string
}


